// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"599166b8","239":"9b8fcc18","453":"8badb202","455":"eed6f1e7"}[chunkId] + ".chunk.js";
};